import { SxProps } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Theme } from "@mui/system";
import { Box, BoxProps } from "components/Core";
import { useState, type ReactNode } from "react";
import { theme } from "theme/theme";

type MenuItemType = {
  label: string | ReactNode;
  onClick: () => void;
};

type Props = {
  ButtonLabel: (prop: any) => JSX.Element;
  menuItems?: MenuItemType[];
  customChild?: ReactNode;
  menuItemContainerProps?: BoxProps;
  menuItemSx?: SxProps<Theme>;
};

export function ReusableMenu({
  ButtonLabel,
  menuItems,
  customChild,
  menuItemContainerProps,
  menuItemSx,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {typeof ButtonLabel === "string" ? (
        <Button
          sx={{
            color: theme.colors.primary,
          }}
          id="menu-button"
          aria-controls={open ? "menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          {ButtonLabel}
        </Button>
      ) : (
        <ButtonLabel
          id="menu-button"
          aria-controls={open ? "menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        />
      )}

      <Menu
        sx={{
          "&.MuiMenu-list": {
            padding: "8px",
          },
        }}
        id="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "menu-button" }}
      >
        <Box {...menuItemContainerProps}>
          {customChild ??
            menuItems?.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  item.onClick();
                  handleClose();
                }}
                sx={menuItemSx}
              >
                {item.label}
              </MenuItem>
            ))}
        </Box>
      </Menu>
    </div>
  );
}
